import Img1 from "../../assets/png/news-1.webp";
import Img2 from "../../assets/png/news-2.webp";
import Img3 from "../../assets/png/news-3.webp";
import Img4 from "../../assets/png/news-4.webp";


const cont1 = <>
    В начале июня прошел юбилейный 10-й сезон турнира BetBoom Streamers Battle. Во флагманском событии приняло участие более 50 человек. В качестве капитанов-новичков в юбилейном сезоне турнира выступила команда Александра «VooDooSh» Шальчинова, Романа «Ramzes666» Кушнарева и Антона «Dyrachyo» Шкредова.
    <br/><br/>
    Турнир завершился зрелищным гранд-финалом между командами двух известных дота-стримеров — Романа «Ramzes666» Кушнарева и Тимура «TpaBoMaH» Хафизова. Победу в напряжённой битве одержала Ramzes Team, воспользовавшись опытом и сыгранностью своих участников. Команда Рамзеса забрала главный приз — 2.000.000₽ из общего призового фонда турнира.
    <br/><br/>
    В составе победителей — Роман «Ramzes666» Кушнарев, Андрей «Afoninje» Афонин, Заур «Cooman» Шахмурзаев, Дмитрий «UnderShock» Большаков и Равшан «RavshanN» Джульпаев.
    <br/><br/>
    После победы игроки пожертвовали часть выигрыша на благотворительность в пользу московского «Приюта Бирюлево», помогая животным, оставшимся без дома.
</>

const cont2 = <>
    Второй сезон турнира BetBoom Streamers Battle по Counter-Strike 2 завершился ярким финалом, объединив в одном ивенте топовых киберспортсменов, стримеров и медийных звёзд.
    <br/><br/>
    Среди участников были настоящие легенды сцены и стриминга: Perfecto, deko, buster, Evelone, Recrent, skywhywalker, Shadowkek, а также представители других дисциплин и шоу-бизнеса: Nix, dyrachyo, MAYOT, SEEMEE, YUNGWAY, 13Kai — турнир стал масштабным пересечением игровых и медийных аудиторий.
    <br/><br/>
    Чемпионами второго сезона стала команда Shadowkek, обыгравшая в финале состав Shoke. Матч закончился со счётом 2:1, а победители получили 1.200.000₽ из призового фонда. Примечательно, что игры команды Shadowkek проходили на буткемпе, специально организованном под турнир.
    <br/><br/>
    BetBoom Streamers Battle по CS2 в очередной раз доказывает, что турнир — это не только про борьбу за победу, но и про шоу, эмоции и топовый контент.
</>

const cont3 = <>
    Стример Артем «ct0m» Максимов при поддержке букмекерской компании BetBoom проведёт турнир по CS2 в формате 2х2 — ct0m Cup 2x2. Организатором ивента выступит Gabe Media, призовой фонд составит 1.000.000 рублей.
    <br/><br/>
    В турнире примет участие 16 игроков, все они — известные стримеры и медийные личности. Среди них: Вадим «Evelone» Козаков, Роман «Mokrivskiy» Мокривский, Евгений «Aunkere» Карьят, Максим «Shadowkek» Павлов, Денис «deko» Жуков, Иван «StRoGo» Шурпатов и другие звезды. Сам ct0m выступит в качестве участника одного из составов.
    <br/><br/>
    Турнир пройдет 5–6 августа, все матчи будут транслироваться в прямом эфире на Twitch-канале ct0m, а все актуальные новости публикуется в <a href="https://t.me/betboomallstar">Telegram-канале</a>.
</>

const cont4 = <>
    10 по 19 августа пройдёт третий сезон легендарного турнира по CS2 среди стримеров. Призовой фонд ивента составит 3.350.000 рублей. Генеральным партнером чемпионата стала букмекерская компания BetBoom, а организатором выступит Gabe Media.
    <br/><br/>
    На BetBoom Streamers Battle CS #3 примут участие 8 команд. Капитанами выступят известные стримеры: shadowkek, skywhywalker, Дмитрий Ликс, by_owl, GUACAMOLEMOLLY, Hooch, Aunkere и Степан CS2NEWS.
    <br/><br/>
    Трансляция турнира пройдет на официальном Twitch-канале <a href="https://www.twitch.tv/betboom_sb_cs">BetBoom Streamers Battle</a>, посмотреть за игрой команд от первого лица можно на каналах участников.
    <br/><br/>
    Чемпионом первого BetBoom Streamers Battle по CS2 стала пятерка Aunkere, а второй турнир серии выиграла команда Shadowkek.
</>

export const newsItems = [
    {
        id: 4,
        title: <>Новый сезон BetBoom Streamers Battle CS2 — что известно на данный момент?</>,
        date: "10/08/25",
        image: Img4,
        content: cont4,
        preview: "С 10 по 19 августа пройдёт третий сезон легендарного турнира по CS2 среди стримеров. Призовой фонд ивента составит 3.350.000 рублей. Генеральным партнером чемпионата стала букмекерская компания BetBoom, а организатором выступит Gabe Media. "
    },
    {
        id: 3,
        title: <>Анонсирован турнир 2х2 от ct0m с призовым фондом 1.000.000 рублей!</>,
        date: "05/08/25",
        image: Img3,
        content: cont3,
        preview: "Стример Артем «ct0m» Максимов при поддержке букмекерской компании BetBoom проведёт турнир по CS2 в формате 2х2 — ct0m Cup 2x2. Организатором ивента выступит Gabe Media, призовой фонд составит 1.000.000 рублей [тоже под вопросом]. "
    },
    {
        id: 2,
        title: <>Юбилейный BetBoom Streamers Battle 10 завершен!</>,
        date: "08/06/25",
        image: Img1,
        content: cont1,
        preview: "В начале июня прошел юбилейный 10-й сезон турнира BetBoom Streamers Battle. Во флагманском событии приняло участие более 50 человек. В качестве капитанов-новичков в юбилейном сезоне турнира выступила команда Александра «VooDooSh» Шальчинова, Романа «Ramzes666» Кушнарева и Антона «Dyrachyo» Шкредова"
    },
    {
        id: 1,
        title: <>Очередной сезон BetBoom Streamers Battle CS2 подошел к концу</>,
        date: "04/05/25",
        image: Img2,
        content: cont2,
        preview: "Второй сезон турнира BetBoom Streamers Battle по Counter-Strike 2 завершился ярким финалом, объединив в одном ивенте топовых киберспортсменов, стримеров и медийных звёзд. Среди участников были настоящие легенды сцены и стриминга"
    },

];


export default newsItems;
